import { render, staticRenderFns } from "./video-box.vue?vue&type=template&id=5863d4bc"
import script from "./video-box.vue?vue&type=script&lang=js"
export * from "./video-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports